module.exports = __webpack_public_path__ + "img/profile-status-icon.27ea301b.svg";